export const REQUEST_START = 'REQUEST_START';
export const REQUEST_END = 'REQUEST_END';

export const requestStart = () => {
	return {
		type: REQUEST_START
	};
};

export const requestEnd = () => {
	return {
		type: REQUEST_END
	};
};



// WEBPACK FOOTER //
// ./frontend/actions/api.js